import { IapAccessTarget } from "common/services/microservices/logging-client";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import WithTracking from "./WithTracking";

interface AuthenticatedRouteProps extends React.ComponentProps<typeof Route> {
  accessTarget: IapAccessTarget;
  authenticated: boolean;
  pass: JSX.Element;
  fail?: JSX.Element;
}

// A wrapper for <Route> that redirects to the login
// screen if the user is not yet authenticated.
export default function AuthenticatedRoute(props: AuthenticatedRouteProps) {
  const { accessTarget, authenticated, pass, fail, ...others } = { ...props };
  const failComponent = fail || <Redirect to="/" />;

  return (
    <Route
      {...others}
      render={({ location }) => (
        <WithTracking location={location}>
          <>{authenticated ? pass : failComponent}</>
        </WithTracking>
      )}
    />
  );
}
